import { StyleSheet } from 'react-native';
import { themes } from 'src/theme/theme';

export const styles = StyleSheet.create({
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9,
  },
  floatingButton: {
    position: 'absolute',
    bottom: 170, // Position above CarrierWidget
    right: 0,
    backgroundColor: themes.light.brand_blue[3],
    paddingVertical: 20,
    paddingLeft: 30,
    paddingRight: 10,
    borderTopLeftRadius: 30,
    borderBottomLeftRadius: 30,
    elevation: 5, // For Android shadow
    zIndex: 10,
  },
  buttonText: {
    color: themes.light.white[1],
    fontWeight: 'bold',
    fontSize: 16,
    textAlign: 'center',
  },
  expandedContainer: {
    position: 'absolute',
    bottom: 170, // Position above CarrierWidget
    right: 0,
    backgroundColor: themes.light.white[1],
    padding: 20,
    borderTopLeftRadius: 10,
    borderBottomLeftRadius: 10,
    minWidth: 450,
    maxWidth: 600,
    elevation: 5,
    zIndex: 10,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    color: themes.light.brand_blue[3],
    marginBottom: 15,
  },
  textInput: {
    borderWidth: 1,
    borderColor: themes.light.gray[3],
    borderRadius: 8,
    padding: 12,
    minHeight: 120,
    maxHeight: 200,
    textAlignVertical: 'top',
    fontSize: 14,
    color: themes.light.black[1],
    backgroundColor: themes.light.white[1],
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 15,
    gap: 10,
  },
  saveButton: {
    backgroundColor: themes.light.brand_blue[3],
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 8,
  },
  cancelButton: {
    backgroundColor: themes.light.white[1],
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: themes.light.gray[3],
  },
  saveButtonText: {
    color: themes.light.white[1],
    fontWeight: 'bold',
    fontSize: 14,
  },
  cancelButtonText: {
    color: themes.light.gray[4],
    fontWeight: 'bold',
    fontSize: 14,
  },
  loadingContainer: {
    borderWidth: 1,
    borderColor: themes.light.gray[3],
    borderRadius: 8,
    padding: 12,
    minHeight: 120,
    maxHeight: 200,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: themes.light.white[1],
  },
  loadingText: {
    fontSize: 16,
    color: themes.light.gray[4],
  },
  characterCount: {
    fontSize: 12,
    color: themes.light.gray[4],
    textAlign: 'right',
    marginTop: 5,
  },
});
